module.exports = __webpack_public_path__ + "static/media/IMG_0386.396fce83.JPG";